module.exports = __webpack_public_path__ + "img/28_67.b9b4600e.png";